"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var __jsx = _react["default"].createElement;

var ShowHide = function ShowHide(props) {
  var isOpen = props.isOpen,
      _props$animated = props.animated,
      animated = _props$animated === void 0 ? true : _props$animated,
      _props$stickToBottom = props.stickToBottom,
      stickToBottom = _props$stickToBottom === void 0 ? false : _props$stickToBottom,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["isOpen", "animated", "stickToBottom"]);
  var containerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(isOpen === true ? null : 0),
      height = _useState[0],
      setHeight = _useState[1];

  (0, _react.useEffect)(function () {
    if (!animated) {
      return;
    }

    if (isOpen && height === 0) {
      setHeight(containerRef.current.clientHeight);
      setTimeout(function () {
        setHeight(null);
      }, 300);
    } else if (!props.isOpen && (height === null || height > 0)) {
      setHeight(containerRef.current.clientHeight);
      setTimeout(function () {
        setHeight(0);
      }, 50);
    }
  }, [isOpen]);

  if (!animated) {
    height = isOpen ? null : 0;
  }

  return __jsx(_Box["default"], restProps, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      transition: "height 0.35s cubic-bezier(0.19, 1, 0.22, 1)",
      overflow: "hidden",
      height: height === null ? "auto" : "".concat(height, "px"),
      width: "100%"
    }
  }, __jsx(_Box["default"], {
    sx: {
      position: height === null ? "relative" : "absolute",
      width: "100%",
      bottom: stickToBottom ? 0 : "auto"
    },
    ref: containerRef
  }, props.children)));
};

var _default = ShowHide;
exports["default"] = _default;